enum YotpoScriptStatus {
	Loading,
	Loaded
}

export default class YotpoLoader {

	private status: YotpoScriptStatus;
	private yotpoTriggers: NodeListOf<HTMLElement>;

	constructor(yotpoTriggers?: NodeListOf<HTMLElement>) {

		if (yotpoTriggers) {
			this.yotpoTriggers = yotpoTriggers;
		} else {
			this.yotpoTriggers = document.querySelectorAll('.js-load-yotpo');
		}

		if (!this.yotpoTriggers.length) return;

		this.setupObservers();

	}

	private loadYotpo() {
		if (typeof (<any>window).yotpo !== 'undefined') {
			(<any>window).yotpo.initWidgets();
			return;
		}
		if (this.status === YotpoScriptStatus.Loaded
			|| this.status === YotpoScriptStatus.Loading) {
				return;
			}
			this.status = YotpoScriptStatus.Loading;
			let yotpoScript = document.createElement("script");
			yotpoScript.type = "text/javascript";
			yotpoScript.async = true;
			yotpoScript.src = `//staticw2.yotpo.com/${this.getApiKey()}/widget.js`;
			yotpoScript.onload = () => {
				this.status = YotpoScriptStatus.Loaded;
			}
			const firstScript = document.getElementsByTagName("script")[0];
			firstScript.parentNode.insertBefore(yotpoScript, firstScript);
	}

	private getApiKey() {
		return document.querySelector("[data-yotpo-api-key]").getAttribute("data-yotpo-api-key");
	}

	private setupObservers() {

		const self = this;

		let observer = new IntersectionObserver(observerCallback, { rootMargin: "0px 0px 250px 0px" });

		function observerCallback(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					self.loadYotpo();
					for (let i = 0; i < self.yotpoTriggers.length; i++) {
						observer.unobserve(self.yotpoTriggers[i]);
					}
				}
			});
		};

		for (let i = 0; i < this.yotpoTriggers.length; i++) {
			observer.observe(this.yotpoTriggers[i]);
		}

	}

}
